import Resource from './common/resource';

class FormRecords extends Resource {
  path = 'form/records';

  onCreateOne({ commit }, { model, res }) {
    commit('update', { model, update: res.data, action: 'prepend' });

    // Update forms count in the collection
    if (res.data?.obj_id) {
      commit(
        'formCollections/adjustFormsCount',
        { collectionId: res.data.obj_id, delta: 1 },
        { root: true }
      );
    }
  }

  onDeleteOne({ commit }, { model }) {
    commit('delete', model.id);

    // Clear submissions count cache
    if (model?.submission_collection_id) {
      commit('clearSubmissionsCount', model.submission_collection_id);
    }

    // Update forms count in the collection
    if (model?.obj_id) {
      commit(
        'formCollections/adjustFormsCount',
        { collectionId: model.obj_id, delta: -1 },
        { root: true }
      );
    }
  }
}

export default FormRecords;
